import { render } from "./BookingPage.vue?vue&type=template&id=2f47a3ef"
import script from "./BookingPage.vue?vue&type=script&lang=js"
export * from "./BookingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__